import '../../../common-assets/styles/external/select2.min.css';
import '../../../common-assets/styles/pages/result-page.scss';
import '../styles/auto-result-page.scss';

import '../../../common-assets/js/components/pagination';
import '../../../common-assets/js/components/favourite_ad';
import '../../../common-assets/js/components/compare_ad';
import '../../../common-assets/js/components/ad_listing_common';
import '../../../common-assets/js/components/search_ad_history';
import { simpleSearch } from './components/simple_search';
import { syncSimpleSearchForm } from './sync_simple_search_form';
import { commonUtils, REGION_OUTSIDE_FINLAND_ID } from '../../../common-assets/js/components/common_utils';
import { searchPriceSlider } from '../../../common-assets/js/components/search/price_search_slider';
import { sliderOptionFormat } from '../../../common-assets/js/components/search/search_slider_format';
import { searchMileageSlider } from './components/mileage_search_slider';

$(async function () {
    // Add this code to replace your existing navigation detection
    window.addEventListener('pageshow', async function (event) {
        // Check if this is a back/forward navigation
        const navType = performance.getEntriesByType('navigation')[0];
        if (event.persisted || (navType && navType.type === 'back_forward')) {
            await syncSimpleSearchForm.loadSimpleSearchForm('init');
            simpleSearch.init();
        }
    });

    await syncSimpleSearchForm.loadSimpleSearchForm('init');
    simpleSearch.init();

    searchPriceSlider.fromElement = $('#simple_search #priceFrom');
    searchPriceSlider.toElement = $('#simple_search #priceTo');
    $('#simple_search #priceFrom, #simple_search #priceTo').on('change', function () {
        sliderOptionFormat.validateRange($(this), searchPriceSlider, false);
    });

    searchMileageSlider.fromElement = $('#simple_search #kilometersFrom');
    searchMileageSlider.toElement = $('#simple_search #kilometersTo');
    $('#simple_search #kilometersFrom, #simple_search #kilometersTo').on('change', function () {
        sliderOptionFormat.validateRange($(this), searchMileageSlider, false);
    });

    let $body = $('body');
    // Save search agent from ad listing page
    $body.on('click', '.saveSearchFromAdListing', async function (e) {
        e.preventDefault();
        const source = $(this).data('source');
        if (!commonUtils.isUserLogin(source)) {
            await almaTunnusLogin.init();
            return;
        }

        // Save the updated searchParams back to storage using IndexedDB
        await advanceSearch.saveSearchAgentData(true);
    });

    // Remove search terms from listing page
    $body.on('click', '.removeAdvanceSearchTerms', async function () {
        const param = $(this).data('param');
        const paramValue = $(this).data('param-value');
        const searchParams = (await searchFormStorage.getFormData()) || {};

        for (const key of Object.keys(searchParams)) {
            if (key === param && Array.isArray(searchParams[key])) {
                if (param === 'excludeCountry') {
                    // For excludeCountry, remove the key from searchParams
                    delete searchParams[key];
                    if (searchParams.locations) {
                        delete searchParams.locations[REGION_OUTSIDE_FINLAND_ID];
                    }
                    break;
                }

                searchParams[key] = searchParams[key].filter(function (value) {
                    return String(value) !== String(paramValue);
                });
            } else if (key === param && typeof searchParams[key] === 'object' && searchParams[key] !== null) {
                // For objects, delete the key that matches paramValue
                if (paramValue in searchParams[key]) {
                    delete searchParams[key][paramValue];
                }
            } else if (key.includes(param) && !Array.isArray(searchParams[key])) {
                if (param === 'includeMakeModel') {
                    delete searchParams.excludeMakeModel;
                } else {
                    delete searchParams[key];
                }
            }
        }

        // Save the updated searchParams back to storage using IndexedDB
        await searchFormStorage.saveFormData(searchParams);
        await advanceSearch.saveSearchAgentData();
    });

    $body.on('click', '.warrantyTooltip', function () {
        let tooltipElement = $(this).next();
        let isTooltipOpened = !tooltipElement.hasClass('none');
        // Hide if already opened other ads tooltip
        $('.warrantyTooltipText').addClass('none');
        // Open/Hide tooltip after hide already opened other ads tooltip
        if (isTooltipOpened) {
            tooltipElement.addClass('none');
        } else {
            tooltipElement.removeClass('none');
        }
    });
});
